function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createRef } from "react";
import ShareURLComponent from "./share_url";
import _ from "underscore";

/**
 * Takes sequence accession as props, fetches the sequence from the server, and
 * displays it in a modal.
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CloudShareModal = /*#__PURE__*/function (_React$Component) {
  function CloudShareModal(props) {
    var _this;
    _classCallCheck(this, CloudShareModal);
    _this = _callSuper(this, CloudShareModal, [props]);
    // Lifecycle methods. //
    _defineProperty(_this, "handleChange", function (e) {
      var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value,
        type = _e$target.type,
        checked = _e$target.checked;
      var inputValue = type === 'checkbox' ? checked : value;
      _this.setState(_defineProperty({}, name, inputValue));
    });
    _defineProperty(_this, "handleSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var email, jobId, requestData, response, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              email = _this.state.email;
              jobId = _this.getJobIdFromPath();
              _this.setState({
                formState: 'loading'
              });
              requestData = {
                job_id: jobId,
                sender_email: email
              };
              _context.prev = 5;
              _context.next = 8;
              return fetch('/cloud_share', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
              });
            case 8:
              response = _context.sent;
              if (response.ok) {
                _context.next = 11;
                break;
              }
              throw new Error('Network response was not ok');
            case 11:
              _context.next = 13;
              return response.json();
            case 13:
              data = _context.sent;
              if (!data.shareable_url) {
                _context.next = 18;
                break;
              }
              _this.setState({
                formState: 'results',
                shareableurl: data.shareable_url
              });
              _context.next = 23;
              break;
            case 18:
              if (!data.errors) {
                _context.next = 22;
                break;
              }
              _this.setState({
                formState: 'error',
                errorMessages: data.errors
              });
              _context.next = 23;
              break;
            case 22:
              throw new Error('Unknown error submitting form');
            case 23:
              _context.next = 28;
              break;
            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](5);
              _this.setState({
                formState: 'error',
                errorMessages: [_context.t0.message]
              });
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[5, 25]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "getJobIdFromPath", function () {
      var regex = /\/([^/]+)(?:\/|#|\?|$)/;
      var match = window.location.pathname.match(regex);
      return match ? match[1] : match;
    });
    _defineProperty(_this, "show", function () {
      var _this$modalRef$curren;
      (_this$modalRef$curren = _this.modalRef.current) === null || _this$modalRef$curren === void 0 || _this$modalRef$curren.showModal();
    });
    _defineProperty(_this, "hide", function () {
      var _this$modalRef$curren2;
      (_this$modalRef$curren2 = _this.modalRef.current) === null || _this$modalRef$curren2 === void 0 || _this$modalRef$curren2.close();
    });
    _this.state = {
      formState: 'input',
      // Possible values: 'input', 'loading', 'results', 'error'
      errorMessages: [],
      email: '',
      agreeToTos: false,
      shareableurl: '',
      isModalVisible: false
    };
    _this.modalRef = /*#__PURE__*/createRef();
    return _this;
  }
  _inherits(CloudShareModal, _React$Component);
  return _createClass(CloudShareModal, [{
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/_jsxs("div", {
        className: "text-center pt-3",
        children: [/*#__PURE__*/_jsx("i", {
          className: "fa fa-spinner fa-3x fa-spin"
        }), /*#__PURE__*/_jsx("p", {
          className: "my-3",
          children: "Uploading the job to SequenceServer Cloud, please wait..."
        })]
      });
    }
  }, {
    key: "renderResults",
    value: function renderResults() {
      var shareableurl = this.state.shareableurl;
      return /*#__PURE__*/_jsx(ShareURLComponent, {
        url: shareableurl,
        querydb: this.props.querydb,
        program: this.props.program,
        queryLength: this.props.queryLength
      });
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var errorMessages = this.state.errorMessages;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [errorMessages.map(function (errorMessage, index) {
          return /*#__PURE__*/_jsx("div", {
            className: "fastan",
            children: /*#__PURE__*/_jsx("div", {
              className: "pt-0 px-0 pb-px",
              children: /*#__PURE__*/_jsx("div", {
                className: "text-danger text-lg border border-danger p-2 my-2",
                children: errorMessage
              })
            })
          }, "fastan-".concat(index));
        }), this.renderForm()]
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this$state = this.state,
        email = _this$state.email,
        agreeToTos = _this$state.agreeToTos;
      var isSubmitDisabled = !agreeToTos;
      return /*#__PURE__*/_jsxs("form", {
        onSubmit: this.handleSubmit,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "px-6 py-4 text-sm",
          children: [/*#__PURE__*/_jsx("label", {
            htmlFor: "emailInput",
            className: "text-seqblue hover:text-orange cursor-pointer mb-0",
            children: "Your Email Address"
          }), /*#__PURE__*/_jsx("input", {
            type: "email",
            id: "emailInput",
            className: "block w-full rounded-md border-0 py-1.5 px-3 mb-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-seqblue sm:text-sm sm:leading-6",
            placeholder: "person@example.com",
            name: "email",
            value: email,
            required: "required",
            onChange: this.handleChange
          }), /*#__PURE__*/_jsxs("p", {
            className: "mb-3",
            children: ["By submitting this form you agree to upload this SequenceServer result set to ", /*#__PURE__*/_jsx("a", {
              href: "https://sequenceserver.com/cloud/",
              target: "_bank",
              className: "text-seqblue hover:text-seqorange",
              children: "SenquenceServer Cloud"
            }), ", where it will become available on the internet to everyone with the link. You also agree that your email address will be stored on SequenceServer databases as proof of authentication for support and similar purposes."]
          }), /*#__PURE__*/_jsxs("div", {
            className: "form-check",
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              id: "tosCheckbox",
              className: "form-check-input",
              name: "agreeToTos",
              checked: agreeToTos,
              onChange: this.handleChange
            }), /*#__PURE__*/_jsxs("label", {
              htmlFor: "tosCheckbox",
              className: "pl-2",
              children: ["\xA0I agree to the ", /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx("a", {
                  href: "https://sequenceserver.com/cloud/terms_and_conditions",
                  target: "_blank",
                  className: "text-seqblue hover:text-seqorange",
                  children: "Terms and Conditions of Service"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6",
          children: /*#__PURE__*/_jsx("button", {
            type: "submit",
            style: {
              backgroundColor: isSubmitDisabled ? '#C74F13' : '#1B557A'
            },
            className: "border-seqblue py-2 px-3 rounded-md text-white",
            disabled: isSubmitDisabled,
            children: "Submit"
          })
        })]
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        formState = _this$state2.formState,
        isModalVisible = _this$state2.isModalVisible;
      var content;
      switch (formState) {
        case 'loading':
          content = this.renderLoading();
          break;
        case 'results':
          content = this.renderResults();
          break;
        case 'error':
          content = this.renderError();
          break;
        case 'input':
        default:
          content = this.renderForm();
          break;
      }
      return /*#__PURE__*/_jsx("div", {
        className: "relative",
        children: /*#__PURE__*/_jsx("dialog", {
          ref: this.modalRef,
          className: "fixed p-4 w-full max-w-2xl bg-transparent focus:outline-none",
          children: /*#__PURE__*/_jsxs("div", {
            className: "relative flex flex-col rounded-lg bg-white shadow",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "flex items-start justify-between rounded-t border-b p-5",
              children: [/*#__PURE__*/_jsx("h3", {
                className: "text-xl font-medium text-gray-900",
                children: "Share to SequenceServer Cloud"
              }), /*#__PURE__*/_jsx("button", {
                className: "ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200",
                onClick: this.hide,
                children: /*#__PURE__*/_jsx("i", {
                  className: "fa-solid fa-xmark hover:text-black"
                })
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "dialog-content",
              children: content
            })]
          })
        })
      });
    }
  }]);
}(React.Component);
export { CloudShareModal as default };